import { render, staticRenderFns } from "./CertificatesType.vue?vue&type=template&id=7bef28a8"
import script from "./CertificatesType.vue?vue&type=script&lang=ts"
export * from "./CertificatesType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports